import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MenuService } from '../../services/menu/menu.service';
import { AuthService } from '../../../services/auth/auth.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { RoutesEnum } from '../../../../shared/models/routes.enum';
import { ACCOUNT_MENU_ITEMS } from './constants/account-menu-items';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, ButtonModule, AvatarModule, MenuModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  private menuService = inject(MenuService);
  private authService = inject(AuthService);
  private router = inject(Router);

  private user$ = this.authService.currentUser$;
  public user = toSignal(this.user$, { initialValue: undefined });

  public userInitials = computed(() => {
    const user = this.user();
    if (user) {
      return user.name[0] + user.surname[0];
    }
    return '';
  });

  menuItems: MenuItem[] = [
    ...ACCOUNT_MENU_ITEMS,
    {
      separator: true,
    },
    {
      label: 'Wyloguj',
      icon: 'pi pi-sign-out',
      command: () => {
        this.authService.logout();
        this.router.navigate([`/${RoutesEnum.Login}`]);
      },
    },
  ];

  public onMenuOpen(): void {
    this.menuService.toggleMenu();
  }
}
